module.exports = __webpack_public_path__ + "img/mir.2d2ee054.svg";